import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // ✅ include the extension

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);
